import L from 'leaflet';

export const radiusWell = 50000;

export const radiusPillar = 20000;

export const CONST_CANTON = 'canton';
export const CONST_HIGHWAY = 'highway';
export const CONST_CANTON_MANHOLE = 'canton_manhole';
export const CONST_HIGHWAY_MANHOLE = 'highway_manhole';
export const CONST_CANTON_PILLAR = 'canton_pillar';
export const CONST_HIGHWAY_PILLAR = 'highway_pillar';
export const CONST_CANTON_COUPLING = 'canton_coupling';
export const CONST_HIGHWAY_COUPLING = 'highway_coupling'; 
export const CONST_CANTON_FOB = 'canton_fob';
export const CONST_HIGHWAY_FOB = 'highway_fob';
export const CONST_CANTON_PON_BOX = 'canton_ponbox';
export const CONST_CANTON_PASSIVE_NODE = 'canton_passive_node';
export const CONST_HIGHWAY_PASSIVE_NODE = 'highway_passive_node';

// ДЛЯ МОЕЙ АВТОРИЗАЦИИ
// export const ROLE_ADMIN = '1';
// export const ROLE_ENGINNER = '2';
// export const ROLE_OPERATOR = '3';
// export const ROLE_MASTER = '4';
// export const ROLE_SENIOR_MASTER = '7';
// export const ROLE_DEFAULT = '5';
// export const ROLE_USER = '6';

// ДЛЯ СЕРВИС АВТОРИЗАЦИИ
export const ROLE_ADMIN = '1';
export const ROLE_ENGINNER = '1415';
export const ROLE_OPERATOR = '3';
export const ROLE_MASTER = '1281';
export const ROLE_SENIOR_MASTER = '1278';
export const ROLE_DEFAULT = '5';
export const ROLE_USER = '6';

export const CABLE = 'Cable';
export const HOUSE = 'House';
export const FOB = 'Fob';
export const COUPLING = 'Coupling';
export const WELL = 'Well';
export const PILLAR = 'Pillar';
export const PON_BOX = 'PonBox';
export const PASSIVE_NODE = 'PassiveNode';

export const CABLE_FLAG = 'Кабель';
export const HOUSE_FLAG = 'Дом';
export const FOB_FLAG= 'Фоб';
export const COUPLING_FLAG = 'Муфта';
export const WELL_FLAG = 'Колодец';
export const PILLAR_FLAG = 'Опора';
export const PON_BOX_FLAG = 'Пон-бокс';
export const NODE_PASSIVE_FLAG = 'Узел';
export const WIFI_POINT_FLAG= 'Wi-Fi';

export const CONST_SUBWAY = 'Подземка';
export const CONST_AIR = 'Воздушка';
export const CONST_BASEMENT = 'Подвал';
export const CONST_FACADE = 'Фасад';
export const CONST_LOFT = 'Чердак';
export const CONST_AIR_INTERHOUSE = 'Воздушка(междомовая)';
export const CONST_AIR_PILLAR = 'Воздушка(по опорам)';

export const icon100pab = new L.Icon({
    iconUrl: './sw.png',
    iconSize: [18, 18],
    iconAnchor: [9, 9],
    popupAnchor: [0, -18],
  });

  export const icon100pabKtv = new L.Icon({
    iconUrl: './sw_ktv.png',
    iconSize: [18, 18],
    iconAnchor: [9, 9],
    popupAnchor: [0, -18],
  });

  export const icon100pabKTV = new L.Icon({
    iconUrl: './sw_ktv.png',
    iconSize: [18, 18],
    iconAnchor: [9, 9],
    popupAnchor: [0, -18],
  });

  export const icon100pabPON = new L.Icon({
    iconUrl: './sw_pon.png',
    iconSize: [18, 18],
    iconAnchor: [9, 9],
    popupAnchor: [0, -18],
  });

  export const icon100pabPON_KTV = new L.Icon({
    iconUrl: './sw_pon_ktv.png',
    iconSize: [18, 18],
    iconAnchor: [9, 9],
    popupAnchor: [0, -18],
  });
  
export const icon3k = new L.Icon({
    iconUrl: './3k.png',
    iconSize: [30, 30],
    iconAnchor: [15, 15],
    popupAnchor: [0, -30],
  });
  
  export const icon3kKtv = new L.Icon({
    iconUrl: './3k_ktv.png',
    iconSize: [30, 30],
    iconAnchor: [15, 15],
    popupAnchor: [0, -30],
  });

export const icon30k = new L.Icon({
    iconUrl: './30k.png',
    iconSize: [40, 40],
    iconAnchor: [20, 20],
    popupAnchor: [0, -40],
  });
  
  export const iconSummit = new L.Icon({
    iconUrl: './summit.png',
    iconSize: [40, 40],
    iconAnchor: [20, 20],
    popupAnchor: [0, -40],
  });
  
export const iconKp = new L.Icon({
    iconUrl: './kp.png',
    iconSize: [20, 20],
    iconAnchor: [10, 10],
    popupAnchor: [0, -20],
  });

export const iconPillar = new L.Icon({
    iconUrl: './pillar.png',
    iconSize: [36, 36],
    iconAnchor: [16, 16],
    popupAnchor: [0, -36],
 });

 export const iconManhole = new L.Icon({
    iconUrl: './manhole.png',
    iconSize: [20, 20],
    iconAnchor: [10, 10],
     popupAnchor: [0, -20]
});

export const iconCoupling = new L.Icon({
  iconUrl: './сoupling.png',
  iconSize: [30, 30],
  iconAnchor: [15, 15],
   popupAnchor: [0, -30]
});

export const iconCouplingCanton = new L.Icon({
  iconUrl: './coupling_canton.png',
  iconSize: [30, 30],
  iconAnchor: [15, 15], 
  popupAnchor: [0, -30] 
});

export const iconFob = new L.Icon({
  iconUrl: './fob.png',
  iconSize: [28, 28],
  iconAnchor: [14, 14], 
  popupAnchor: [0, -28] 
});

export const iconPonBox = new L.Icon({
  iconUrl: './ponbox.png',
  iconSize: [22, 22],
  iconAnchor: [11, 11], 
  popupAnchor: [0, -22] 
});

export const iconPassiveNode = new L.Icon({
  iconUrl: './passive_node.png',
  iconSize: [22, 22],
  iconAnchor: [11, 11], 
  popupAnchor: [0, -22] 
});

export const iconPassiveNodeKtv = new L.Icon({
  iconUrl: './passive_node_ktv.png',
  iconSize: [22, 22],
  iconAnchor: [11, 11], 
  popupAnchor: [0, -22] 
});

export const iconAmplifier = new L.Icon({
  iconUrl: './amplifier.png',
  iconSize: [36, 36],
  iconAnchor: [18, 18], 
  popupAnchor: [0, -36] 
});

export const iconOp = new L.Icon({
  iconUrl: './op.png',
  iconSize: [22, 22],
  iconAnchor: [11, 11], 
  popupAnchor: [0, -22] 
});

export const iconFobCanton = new L.Icon({
  iconUrl: './fob_canton.png',
  iconSize: [28, 28],
  iconAnchor: [14, 14], 
  popupAnchor: [0, -28] 
});

export const iconHouse = new L.Icon({
  iconUrl: './house.png',
  iconSize: [20, 20],
  iconAnchor: [10, 10],
   popupAnchor: [0, -20]
});

export const iconHouseAct = new L.Icon({
  iconUrl: './house_act.png',
  iconSize: [20, 20],
  iconAnchor: [10, 10],
   popupAnchor: [0, -20]
});

export const iconProblem = new L.Icon({
  iconUrl: './problem.png',
  iconSize: [20, 20],
  iconAnchor: [10, 10],
  popupAnchor: [0, -20],
});

export const iconDividerApc = new L.Icon({
  iconUrl: './divider_apc2.png',
  iconSize: [26, 26],
  iconAnchor: [13, 13],
  popupAnchor: [0, -26],
});

export const iconDividerUpc = new L.Icon({
  iconUrl: './divider_upc2.png',
  iconSize: [26, 26],
  iconAnchor: [13, 13],
  popupAnchor: [0, -26],
});


export const iconHouseNotActivated = new L.Icon({
 iconUrl: './house_not_activated.png' , 
  iconSize: [20, 20],
  iconAnchor: [10, 10],
   popupAnchor: [0, -20]
});

export const iconHouseActivated = new L.Icon({
  iconUrl: './house_activated.png',
  iconSize: [20, 20],
  iconAnchor: [10, 10],
   popupAnchor: [0, -20]
});

export const iconWifiAp = new L.Icon({
  iconUrl: './wifi_ap.png',
  iconSize: [30, 30],
  iconAnchor: [15, 23],
   popupAnchor: [0, -30]
});

export const iconWifiBSPlanned = new L.Icon({
  iconUrl: './planned_wifi_bs.png',
  iconSize: [30, 30],
  iconAnchor: [15, 23],
   popupAnchor: [0, -30]
});

export const iconWifiHotspot = new L.Icon({
  iconUrl: './wifi_hotspot.png',
  iconSize: [40, 40],
  iconAnchor: [20, 20], 
  popupAnchor: [0, -40] 
});

export const iconWifiAPPlanned = new L.Icon({
  iconUrl: './planned_wifi_ap.png',
  iconSize: [50, 50],
  iconAnchor: [25, 25],
   popupAnchor: [0, -50]
});

export const iconWifiStation = new L.Icon({
  iconUrl: './wifi_station.png',
  iconSize: [30, 30],
  iconAnchor: [15, 23], 
  popupAnchor: [0, -30] 
});

export const iconWifiSTPlanned = new L.Icon({
  iconUrl: './planned_wifi_st.png',
  iconSize: [30, 30],
  iconAnchor: [15, 23],
   popupAnchor: [0, -30]
});